module.exports = __webpack_public_path__ + "static/img/build-our-brand.c0263b0f.png";